/**
 * Password reset handler
 */
import { pushFunnelEvent } from '@utils/dataLayer';
import BaseHandler from './BaseHandler';
import DOMUtils from '../utils/DOMUtils';
import FormValidator from '../utils/FormValidator';
import { FORM_SELECTORS, FIELD_SELECTORS, MESSAGE_SELECTORS } from '../constants';

class PasswordResetHandler extends BaseHandler {
  constructor(form, api, stepNavigator, messages) {
    super(form, api, stepNavigator, messages);
    this.validator = new FormValidator(messages);
    this.initResetPasswordEmail();
  }

  /**
   * Handle password reset request
   */
  async handleResetPassword(email) {
    const emailInput = this.form.querySelector(FIELD_SELECTORS.resetEmail);

    if (!FormValidator.validateEmail(email)) {
      DOMUtils.showError(emailInput, this.messages.getMessage('error_email_invalid'));
      return;
    }
    // Set loading state immediately
    const resetPasswordForm = this.form.querySelector(FORM_SELECTORS.resetPassword);
    if (resetPasswordForm) {
      DOMUtils.setLoading(resetPasswordForm, true, this.form);
    }

    // Track Send button click
    pushFunnelEvent({
      section: 'Forgot Password',
      step: 2,
      label: 'Forgot Password - Sign In Button',
      method: 'Email',
    });

    await this.handleApiCall(
      FORM_SELECTORS.resetPassword,
      () => this.api.resetPassword(email, DOMUtils.getCurrentPageUrl()),
      {
        messageElement: this.form.querySelector(MESSAGE_SELECTORS.resetMessage),
        successMessageKey: 'message_reset_password_sent',
        errorMessageKey: 'error_resend_verification',
        successCallback: () => {
          if (resetPasswordForm) {
            const submitButton = resetPasswordForm.querySelector('button[type="submit"]');
            if (submitButton) {
              // eslint-disable-next-line no-param-reassign
              submitButton.setAttribute('data-force-disabled', 'true');
              submitButton.disabled = true;
            }
          }
        },
        errorCallback: (data) => {
          const errorMessage = this.getErrorMessage(data, 'error_resend_verification');

          // Track error
          pushFunnelEvent({
            section: 'Forgot Password',
            step: 2,
            label: 'Forgot Password - Error',
            method: 'Email',
            errorMessage,
          });
        },
      },
    );
  }
}

export default PasswordResetHandler;
